import React from 'react';
import { Breakpoint, ControlLink, Text, Stack } from '@moda/om';
import { hrefFor } from '../../../routers';
import { Order, OrderItem, OrderItemStatusGroup } from '../../../hooks/useOrder';
import { ReturnBasedOnPromo } from '../ReturnOrderItem/ReturnBasedOnPromo';

import './AccountOrderItemDetailsDesktop.scss';

interface Props {
  item?: OrderItem;
  order?: Order;
  showShippingStatus?: boolean;
  showTrackAndReturn?: boolean;
}

export const AccountOrderItemDetailsDesktop: React.FC<Props> = ({
  item,
  order,
  showTrackAndReturn = false,
  showShippingStatus = true
}) => {
  if (!item) return null;

  return (
    <Breakpoint gt="sm">
      <Stack space={1} className="AccountOrderItemDetailsDesktop__status-container">
        {showShippingStatus && (
          <section className="AccountOrderItemDetailsDesktop__status">
            {item.attributes.shippingStatus && (
              <Stack space={1}>
                <Text treatment="body2" color="cement">
                  Status
                </Text>

                <Text treatment="body2" color="ink">
                  {typeof item.attributes.shippingStatus === 'string'
                    ? item.attributes.shippingStatus
                    : 'Returned'}
                </Text>
              </Stack>
            )}
          </section>
        )}
        {showTrackAndReturn && (
          <>
            {item.attributes.shipmentTrackingUrl && (
              <section className="AccountOrderItemDetailsDesktop__tracking">
                <ControlLink
                  href={item.attributes.shipmentTrackingUrl}
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  <Text treatment="body2" color="ink">
                    Track Shipment
                  </Text>
                </ControlLink>
              </section>
            )}

            {item.attributes.isReturnable &&
              item.attributes.statusGroup === OrderItemStatusGroup.Shipped &&
              order &&
              order.attributes.orderNumber &&
              !ReturnBasedOnPromo(item) && (
                <section>
                  <ControlLink
                    to={hrefFor.RequestReturnPage({
                      orderNumber: order.attributes.orderNumber
                    })}
                  >
                    <Text treatment="body2" color="ink">
                      Request Return
                    </Text>
                  </ControlLink>
                </section>
              )}
          </>
        )}
      </Stack>
    </Breakpoint>
  );
};
